import React,{useEffect,useState} from "react";
import { auth, db, storage } from "../../firebase/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

export default function BusinessSettings(){
  const [businessId,setBusinessId] = useState(null);
  const [loading,setLoading] = useState(true);
  const [saving,setSaving] = useState(false);
  const [uploading,setUploading] = useState(false);

  const [form,setForm] = useState({
    customHeader:"",
    primaryColor:"#4f46e5",
    accentColor:"#6366f1",
    logoURL:"",
    domain:""
  });

  /* LOAD BUSINESS ID */
  useEffect(()=>{
    const unsub = auth.onAuthStateChanged(async(user)=>{
      if(!user) return;

      const snap = await getDoc(doc(db,"users",user.uid));
      if(snap.exists()){
        setBusinessId(snap.data().businessId);
      }
      setLoading(false);
    });

    return ()=>unsub();
  },[]);

  /* LOAD BRANDING */
  useEffect(()=>{
    if(!businessId) return;

    (async()=>{
      const refDoc = doc(db,"businesses",businessId,"settings","branding");
      const snap = await getDoc(refDoc);
      if(snap.exists()){
        setForm(f=>({...f,...snap.data()}));
      }
    })();
  },[businessId]);

  const field = k => e => setForm({...form,[k]:e.target.value});

  /* LOGO UPLOAD */
  const uploadLogo = async(file)=>{
    if(!file || !businessId) return;

    try{
      setUploading(true);

      const fileRef = ref(
        storage,
        `branding/businesses/${businessId}/logo.png`
      );

      await uploadBytes(fileRef,file);
      const url = await getDownloadURL(fileRef);

      setForm(f=>({...f,logoURL:url}));
    }catch(err){
      console.error("Logo upload failed",err);
      alert("Logo upload failed");
    }finally{
      setUploading(false);
    }
  };

  /* SAVE */
  const save = async()=>{
    if(!businessId) return;

    try{
      setSaving(true);
      await setDoc(
        doc(db,"businesses",businessId,"settings","branding"),
        {...form,updatedAt:new Date().toISOString()},
        {merge:true}
      );
      alert("Business branding saved");
    }catch(err){
      console.error("Save failed",err);
      alert("Save failed");
    }finally{
      setSaving(false);
    }
  };

  if(loading){
    return <div className="min-h-screen flex items-center justify-center text-white bg-black">Loading…</div>;
  }

  return(
    <div className="min-h-screen bg-black text-white p-8">
      <h2 className="text-3xl mb-6">Branding Settings</h2>

      <div className="space-y-4 max-w-xl">
        <label>Business Name</label>
        <input className="w-full p-2 bg-neutral-800 rounded" value={form.customHeader} onChange={field("customHeader")} />

        <label>Primary Color</label>
        <input type="color" value={form.primaryColor} onChange={field("primaryColor")} />

        <label>Accent Color</label>
        <input type="color" value={form.accentColor} onChange={field("accentColor")} />

        <label>Domain</label>
        <input className="w-full p-2 bg-neutral-800 rounded" value={form.domain} onChange={field("domain")} />

        <label className="cursor-pointer bg-neutral-800 px-4 py-2 rounded inline-block">
          {uploading ? "Uploading…" : "Upload Logo"}
          <input hidden type="file" accept="image/*" onChange={e=>uploadLogo(e.target.files[0])} />
        </label>

        {form.logoURL && <img src={form.logoURL} className="w-28 mt-4 rounded" />}

        <button
          onClick={save}
          disabled={saving}
          className="bg-blue-600 px-6 py-2 rounded mt-4"
        >
          {saving ? "Saving…" : "Save"}
        </button>
      </div>
    </div>
  );
}
